export type AnalyticsDashboard = {
  id: string
  label: string
  /** Any oEmbed-compatible URL (Mixpanel boards, reports, etc.) */
  url: string
}

/**
 * Dashboards are embedded via the oEmbed protocol.
 * The backend fetches embed HTML from the provider's oEmbed endpoint.
 *
 * @see https://docs.mixpanel.com/docs/features/embeds
 * @see https://oembed.com
 */
export const ANALYTICS_DASHBOARDS: AnalyticsDashboard[] = [
  {
    id: "overview",
    label: "Overview",
    url: "https://eu.mixpanel.com/project/3446352/view/3949436/app/boards#id=8365400",
  },
  {
    id: "board-2",
    label: "Board 2",
    url: "https://eu.mixpanel.com/s/1fPsyT",
  },
]
